// Template216: Osaka - Cómo moverse (Subway)
// Header, intro, Metro box, Pases, Google Maps tip, Otros transportes, sticker + ICOCA tip.

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";

const Template216 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;
	const intro = page?.texts?.[1]?.content;
	const metroTitle = page?.texts?.[2]?.content;
	const metroList = page?.texts?.[3]?.content;
	const pasesTitle = page?.texts?.[4]?.content;
	const pasesList = page?.texts?.[5]?.content;
	const googleTip = page?.texts?.[6]?.content;
	const otrosTitle = page?.texts?.[7]?.content;
	const otrosList = page?.texts?.[8]?.content;
	const icocaTip = page?.texts?.[9]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const stickerImage = getImageSrc("sticker");
	const logoImage = getCanvasImageUrl("logo");
	const actualHeaderColor = headerBackgroundColor || "#1F4E3D";

	const contentColor = textColor || "#444";
	const headingColor = textColor || "#1F4E3D";

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		marginBottom: "8px",
		marginTop: 0,
		color: headingColor,
	};

	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: contentColor,
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				color: contentColor,
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *:not([data-template-header])": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
					color: "inherit",
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
				{logoImage && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: isSmallScreen ? 66 : 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			{intro && (
				<Box data-block-id="text-1" sx={{ padding: "12px 16px", fontSize: 13, color: contentColor }}>
					<Box component="p" sx={estiloP}>
						{intro}
					</Box>
				</Box>
			)}

			<Box data-block-id="text-2" sx={{ position: "relative", flex: 1 }}>
				{(metroTitle || metroList) && (
					<Box
						sx={{
							backgroundColor: "#d1e6de",
							border: "2px solid #1F4E3D",
							borderRadius: "16px",
							padding: 2,
							margin: "0 16px 16px 16px",
							position: "relative",
						}}
					>
						{metroTitle && (
							<Box component="h3" sx={estiloH3}>
								{metroTitle}
							</Box>
						)}
						{metroList && (
							<Box
								component="ul"
								sx={{ paddingLeft: 2.25, margin: 0, fontSize: 13 }}
								dangerouslySetInnerHTML={{ __html: metroList }}
							/>
						)}
					</Box>
				)}

				<Box sx={{ padding: "0 16px", fontSize: 13, color: contentColor }}>
					{pasesTitle && (
						<Box component="h3" sx={estiloH3}>
							{pasesTitle}
						</Box>
					)}
					{pasesList && (
						<Box
							component="ul"
							sx={{ paddingLeft: 2.25 }}
							dangerouslySetInnerHTML={{ __html: pasesList }}
						/>
					)}
				</Box>

				{googleTip && (
					<Box sx={{ padding: "0 16px" }}>
						<Box
							sx={{
								backgroundColor: "#d1e6de",
								border: "2px solid #1F4E3D",
								borderRadius: "12px",
								padding: "10px 12px",
								marginTop: 1,
								fontSize: 13,
								color: contentColor,
							}}
						>
							{googleTip}
						</Box>
					</Box>
				)}

				<Box
					sx={{
						padding: "12px 16px",
						fontSize: 13,
						color: contentColor,
						marginTop: 2,
						marginBottom: isSmallScreen ? 12 : 0,
					}}
				>
					{otrosTitle && (
						<Box component="h3" sx={estiloH3}>
							{otrosTitle}
						</Box>
					)}
					{otrosList && (
						<Box
							component="ul"
							sx={{ paddingLeft: 2.25 }}
							dangerouslySetInnerHTML={{ __html: otrosList }}
						/>
					)}
				</Box>

				{stickerImage && (
					<Box
						component="img"
						src={stickerImage}
						alt=""
						sx={{
							width: 110,
							position: "absolute",
							bottom: isSmallScreen ? -30 : 0,
							right: isSmallScreen ? 12 : 12,
						}}
					/>
				)}
				{icocaTip && (
					<Box
						sx={{
							position: "absolute",
							bottom: isSmallScreen ? 50 : 80,
							right: isSmallScreen ? 60 : 30,
							backgroundColor: "#fff8db",
							border: "2px solid #f5c400",
							borderRadius: "16px 16px 0px 16px",
							padding: "10px 12px",
							fontSize: 11,
							color: contentColor,
							boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
							maxWidth: isSmallScreen ? 200 : 112,
						}}
						dangerouslySetInnerHTML={{ __html: icocaTip }}
					/>
				)}
			</Box>
		</Box>
	);
};

Template216.thumbnail = "/images/template-1.png";
export default Template216;
